import { observer } from "mobx-react";
import {Card, Button} from "@ann/web-components";
import {BannerCard, BannerContentWrapper, BannerWrapper} from "./BannerSelected.styled";
import React from "react";

export const BannerSelected = observer(({ store, onShare, onMove, selectionStore }) => {
    const activeSelectionStore = selectionStore || store?.selectionStore;
    const { countSelectedDocuments, countSelectedFolders } = activeSelectionStore;

    const existSelectedElements = React.useMemo(() => {
        if (countSelectedFolders > 0) return true;
        return countSelectedDocuments > 0;

    }, [countSelectedDocuments, countSelectedFolders]);

    const numberOfItemsSelected = React.useMemo(() => countSelectedFolders + countSelectedDocuments, [countSelectedDocuments, countSelectedFolders]);
    const labelItemsSelected = React.useMemo(() => {
        if ((countSelectedFolders > 0 && countSelectedDocuments > 0) || countSelectedFolders > 1 || countSelectedDocuments > 1) {
            return 'Items';
        } else if (countSelectedFolders === 1) {
            return 'Folder';
        } else {
            return 'Document';
        }

    }, [countSelectedFolders, countSelectedDocuments]);

    return existSelectedElements ? (
        <BannerCard>
            <Card size="small">
                <BannerWrapper>
                    <BannerContentWrapper>
                        {`${numberOfItemsSelected} ${labelItemsSelected} Selected`}
                        <Button
                            icon="personAdd"
                            label=""
                            pill
                            size="small"
                            type="tertiary"
                            onClick={() => onShare && onShare()}
                        />
                        <Button
                            icon="download"
                            label=""
                            pill
                            size="small"
                            type="tertiary"
                            disabled={true}
                            onClick={() => console.log('Download clicked')}
                        />
                        <Button
                            icon="driveFileMove"
                            label=""
                            pill
                            size="small"
                            type="tertiary"
                            onClick={() => onMove && onMove()}
                        />
                    </BannerContentWrapper>
                    <Button
                        icon="close"
                        label=""
                        pill
                        size="small"
                        type="tertiary"
                        onClick={() => activeSelectionStore.clearSelections()}
                    />
                </BannerWrapper>
            </Card>
        </BannerCard>
    ): (<></>);
});
